import type { FeatureFlagKey, FeatureFlags } from "@/hooks/useFeatureFlags";

/** Map of route path prefix → required feature flag. */
export const ROUTE_FLAG_MAP: { prefix: string; flag: FeatureFlagKey }[] = [
  { prefix: "/console/dispatch", flag: "dispatch" },
  { prefix: "/tracking", flag: "gps_tracking" },
  { prefix: "/operations/live", flag: "gps_tracking" },
  { prefix: "/vehicle-admin", flag: "fleet" },
  { prefix: "/vehicle-inspection", flag: "fleet" },
  { prefix: "/equipment", flag: "fleet" },
  { prefix: "/schedule", flag: "scheduling" },
  { prefix: "/assignments", flag: "scheduling" },
  { prefix: "/analytics", flag: "advanced_analytics" },
  { prefix: "/dashboards", flag: "advanced_analytics" },
  { prefix: "/time-clock", flag: "time_clock_enabled" },
  { prefix: "/sos", flag: "sos_enabled" },
];

export function requiredFlagForPath(path: string): FeatureFlagKey | undefined {
  // longest prefix wins
  const match = ROUTE_FLAG_MAP
    .filter((m) => path === m.prefix || path.startsWith(m.prefix + "/"))
    .sort((a, b) => b.prefix.length - a.prefix.length)[0];
  return match?.flag;
}

export function isPathEnabled(path: string, flags: FeatureFlags): boolean {
  const required = requiredFlagForPath(path);
  if (!required) return true;
  return flags[required] !== false;
}
